import { Trans, useTranslation } from 'react-i18next';

interface IChatLayoutProps {
  children: React.ReactNode;
}

function ChatLayout(props: IChatLayoutProps) {
  const { t } = useTranslation();

  return (
    <main className="p-2 bg-xircle-main text-white rounded-2xl py-4">
      <header className="flex justify-between items-center gap-4 px-2">
        <section className="flex flex-col justify-start items-start">
          <h3 className="m-0 font-normal text-2xl leading-7 tracking-normal">
            <Trans i18nKey="header.title" t={t}>
              <b>w</b>
            </Trans>
          </h3>
          <h4 className="m-0 font-normal text-base leading-6">{t('header.subtitle')}</h4>
        </section>
        <section>{/* [todo]: Add "Powered by esanum" */}</section>
      </header>
      {props.children}
    </main>
  );
}

export default ChatLayout;
